import e from "react";
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const b = /* @__PURE__ */ new Set(["children", "localName", "ref", "style", "className"]), f = /* @__PURE__ */ new WeakMap(), k = (v, c, u, p, V) => {
  const a = V == null ? void 0 : V[c];
  a === void 0 || u === p ? u == null && c in HTMLElement.prototype ? v.removeAttribute(c) : v[c] = u : ((o, d, g) => {
    let l = f.get(o);
    l === void 0 && f.set(o, l = /* @__PURE__ */ new Map());
    let m = l.get(d);
    g !== void 0 ? m === void 0 ? (l.set(d, m = { handleEvent: g }), o.addEventListener(d, m)) : m.handleEvent = g : m !== void 0 && (l.delete(d), o.removeEventListener(d, m));
  })(v, a, u);
};
function s(v = window.React, c, u, p, V) {
  let a, o, d;
  if (c === void 0) {
    const i = v;
    ({ tagName: o, elementClass: d, events: p, displayName: V } = i), a = i.react;
  } else
    a = v, d = u, o = c;
  const g = a.Component, l = a.createElement, m = new Set(Object.keys(p ?? {}));
  class h extends g {
    constructor() {
      super(...arguments), this.o = null;
    }
    t(t) {
      if (this.o !== null)
        for (const N in this.i)
          k(this.o, N, this.props[N], t ? t[N] : void 0, p);
    }
    componentDidMount() {
      this.t();
    }
    componentDidUpdate(t) {
      this.t(t);
    }
    render() {
      const { _$Gl: t, ...N } = this.props;
      this.h !== t && (this.u = (n) => {
        t !== null && ((r, E) => {
          typeof r == "function" ? r(E) : r.current = E;
        })(t, n), this.o = n, this.h = t;
      }), this.i = {};
      const y = { ref: this.u };
      for (const [n, r] of Object.entries(N))
        b.has(n) ? y[n === "className" ? "class" : n] = r : m.has(n) || n in d.prototype ? this.i[n] = r : y[n] = r;
      return l(o, y);
    }
  }
  h.displayName = V ?? d.name;
  const C = a.forwardRef((i, t) => l(h, { ...i, _$Gl: t }, i == null ? void 0 : i.children));
  return C.displayName = h.displayName, C;
}
const B = s({
  react: e,
  tagName: "vds-button",
  elementClass: customElements.get("vds-button"),
  events: { onVdsBlur: "vds-blur", onVdsFocus: "vds-focus" },
  displayName: "VdsButton"
}), I = s({
  react: e,
  tagName: "vds-icon",
  elementClass: customElements.get("vds-icon"),
  events: {},
  displayName: "VdsIcon"
}), S = s({
  react: e,
  tagName: "vds-link",
  elementClass: customElements.get("vds-link"),
  events: { onVdsFocus: "vds-focus", onVdsBlur: "vds-blur" },
  displayName: "VdsLink"
}), x = s({
  react: e,
  tagName: "vds-inline-banner",
  elementClass: customElements.get(
    "vds-inline-banner"
  ),
  events: { onVdsShow: "vds-show", onVdsHide: "vds-hide" },
  displayName: "VdsInlineBanner"
}), F = s({
  react: e,
  tagName: "vds-modal",
  elementClass: customElements.get("vds-modal"),
  events: { onVdsClose: "vds-close" },
  displayName: "VdsModal"
}), G = s({
  react: e,
  tagName: "vds-pinned-banner",
  elementClass: customElements.get(
    "vds-pinned-banner"
  ),
  events: {},
  displayName: "VdsPinnedBanner"
}), R = s({
  react: e,
  tagName: "vds-skeleton",
  elementClass: customElements.get("vds-skeleton"),
  events: {},
  displayName: "VdsSkeleton"
}), T = s({
  react: e,
  tagName: "vds-tooltip",
  elementClass: customElements.get("vds-tooltip"),
  events: {},
  displayName: "VdsTooltip"
}), H = s({
  react: e,
  tagName: "vds-checkbox",
  elementClass: customElements.get("vds-checkbox"),
  events: {
    onVdsBlur: "vds-blur",
    onVdsFocus: "vds-focus",
    onVdsChange: "vds-change"
  },
  displayName: "VdsCheckbox"
}), M = s({
  react: e,
  tagName: "vds-datepicker",
  elementClass: customElements.get("vds-datepicker"),
  events: {
    onVdsInput: "vds-input",
    onVdsFocus: "vds-focus",
    onVdsBlur: "vds-blur"
  },
  displayName: "VdsDatepicker"
}), O = s({
  react: e,
  tagName: "vds-input",
  elementClass: customElements.get("vds-input"),
  events: {
    onVdsInput: "vds-input",
    onVdsFocus: "vds-focus",
    onVdsBlur: "vds-blur"
  },
  displayName: "VdsInput"
}), P = s({
  react: e,
  tagName: "vds-password",
  elementClass: customElements.get("vds-password"),
  events: {
    onVdsInput: "vds-input",
    onVdsFocus: "vds-focus",
    onVdsBlur: "vds-blur"
  },
  displayName: "VdsPassword"
}), D = s({
  react: e,
  tagName: "vds-radio",
  elementClass: customElements.get("vds-radio"),
  events: { onVdsBlur: "vds-blur", onVdsFocus: "vds-focus" },
  displayName: "VdsRadio"
}), L = s({
  react: e,
  tagName: "vds-radio-group",
  elementClass: customElements.get("vds-radio-group"),
  events: { onVdsChange: "vds-change" },
  displayName: "VdsRadioGroup"
}), A = s({
  react: e,
  tagName: "vds-search",
  elementClass: customElements.get("vds-search"),
  events: {
    onVdsInput: "vds-input",
    onVdsFocus: "vds-focus",
    onVdsBlur: "vds-blur"
  },
  displayName: "VdsSearch"
}), j = s({
  react: e,
  tagName: "vds-select",
  elementClass: customElements.get("vds-select"),
  events: {
    onVdsShow: "vds-show",
    onVdsAfterShow: "vds-after-show",
    onVdsHide: "vds-hide",
    onVdsAfterHide: "vds-after-hide",
    onVdsChange: "vds-change"
  },
  displayName: "VdsSelect"
}), _ = s({
  react: e,
  tagName: "vds-textarea",
  elementClass: customElements.get("vds-textarea"),
  events: {
    onVdsInput: "vds-input",
    onVdsFocus: "vds-focus",
    onVdsBlur: "vds-blur"
  },
  displayName: "VdsTextarea"
}), $ = s({
  react: e,
  tagName: "vds-card",
  elementClass: customElements.get("vds-card"),
  events: {},
  displayName: "VdsCard"
}), U = s({
  react: e,
  tagName: "vds-grid",
  elementClass: customElements.get("vds-grid"),
  events: {},
  displayName: "VdsGrid"
}), W = s({
  react: e,
  tagName: "vds-tag",
  elementClass: customElements.get("vds-tag"),
  events: { onVdsDelete: "vds-delete" },
  displayName: "VdsTag"
}), q = s({
  react: e,
  tagName: "vds-popup",
  elementClass: customElements.get("vds-popup"),
  events: { onVdsReposition: "vds-reposition" },
  displayName: "VdsPopup"
}), z = s({
  react: e,
  tagName: "vds-visually-hidden",
  elementClass: customElements.get(
    "vds-visually-hidden"
  ),
  events: {},
  displayName: "VdsVisuallyHidden"
}), J = s({
  react: e,
  tagName: "vds-skeletonbar",
  elementClass: customElements.get(
    "vds-skeletonbar"
  ),
  events: {},
  displayName: "VdsSkeletonBar"
}), K = s({
  react: e,
  tagName: "vds-optgroup",
  elementClass: customElements.get("vds-optgroup"),
  events: {},
  displayName: "VdsOptgroup"
}), Q = s({
  react: e,
  tagName: "vds-option",
  elementClass: customElements.get("vds-option"),
  events: {},
  displayName: "VdsOption"
}), X = s({
  react: e,
  tagName: "vds-grid-item",
  elementClass: customElements.get("vds-grid-item"),
  events: {},
  displayName: "VdsGridItem"
});
export {
  B as VdsButton,
  $ as VdsCard,
  H as VdsCheckbox,
  M as VdsDatepicker,
  U as VdsGrid,
  X as VdsGridItem,
  I as VdsIcon,
  x as VdsInlineBanner,
  O as VdsInput,
  S as VdsLink,
  F as VdsModal,
  K as VdsOptgroup,
  Q as VdsOption,
  P as VdsPassword,
  G as VdsPinnedBanner,
  q as VdsPopup,
  D as VdsRadio,
  L as VdsRadioGroup,
  A as VdsSearch,
  j as VdsSelect,
  R as VdsSkeleton,
  J as VdsSkeletonBar,
  W as VdsTag,
  _ as VdsTextarea,
  T as VdsTooltip,
  z as VdsVisuallyHidden
};
//# sourceMappingURL=react.mjs.map
